/** Give visible content a head start, then request a fresh idle turn for optional work. */
export function scheduleIdleTask(callback: () => void, delayMs: number): () => void {
  let idleId: number | undefined;
  const timer = window.setTimeout(() => {
    if ('requestIdleCallback' in window && typeof window.requestIdleCallback === 'function') {
      // No timeout: optional warming must not force work onto a busy main thread.
      idleId = window.requestIdleCallback(callback);
    } else {
      callback();
    }
  }, delayMs);
  return () => {
    window.clearTimeout(timer);
    if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
  };
}
